// Copied verbatim from eval/dashboard/internal_web/src/components/ui/NullNote.tsx (ATM-57). Keep in step until ATM-60 shares it.
import { Info } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "../../lib/cn";

type Props = {
  /** Why the value is unknowable — a denominator, a level count, a floor. */
  children: ReactNode;
  className?: string;
};

/**
 * The explanation that has to travel with every em dash.
 *
 * The API returns `null` — never `0.0` — for a rate it cannot compute, and a
 * bare em dash reads as a bug. This says which denominator was empty ("no
 * high-acuity sessions in scope", "one presenting level only", "denominator
 * below the n = 12 floor"), so the gap in the data is legible as a fact.
 */
export default function NullNote({ children, className }: Props) {
  return (
    <span className={cn("flex items-start gap-1.5 text-xs text-ink-muted", className)}>
      <Info size={12} className="mt-0.5 shrink-0" aria-hidden />
      <span>{children}</span>
    </span>
  );
}
